import { removeToken } from './token';

const INACTIVITY_LIMIT = 30 * 60 * 1000;
let inactivityTimer: NodeJS.Timeout | null = null;

const resetInactivityTimer = () => {
  if (inactivityTimer) clearTimeout(inactivityTimer);

  inactivityTimer = setTimeout(() => {
    console.warn('Usuário inativo por 30 minutos. Deslogando...');
    removeToken(
      'Token expirado por inatividade, você será redirecionado para realizar login novamente.',
    );
  }, INACTIVITY_LIMIT);
};

export const startInactivityWatcher = () => {
  resetInactivityTimer();

  const activityEvents = ['mousemove', 'keydown', 'scroll', 'click'];

  activityEvents.forEach(event => {
    window.addEventListener(event, resetInactivityTimer);
  });
};

export const stopInactivityWatcher = () => {
  if (inactivityTimer) clearTimeout(inactivityTimer);
  const activityEvents = ['mousemove', 'keydown', 'scroll', 'click'];
  activityEvents.forEach(event => {
    window.removeEventListener(event, resetInactivityTimer);
  });
};
